<template>
  <a-modal
    v-model="show"
    :centered="true"
    :keyboard="false"
    :footer="null"
    :width="700"
    @cancel="handleCancleClick"
    title="提现申请">
    <a-layout class="user-info">
      <div class="z-row align-items-center justify-content-left z_mb10">
        <div class="z-col-xs-6 z-row align-items-center justify-content-left">
          <div class=" z-col-auto ju_title3">
              可提现余额：
          </div>
          <div class="col">
              <span style="color: orange">{{ currency }}{{CompanyInfoData.availableBalance}}</span>
          </div>
          <div class="z-col-xs-8">
            <a-form-item v-bind="formItemLayout">
              <a-input-number placeholder="请输入提现金额" v-model="amount" style="width: 160px"/>
              <a-button style="margin-right: .8rem;width: 83px;" @click="allIn">全部提现</a-button>
              <a-button  type="primary" @click="handleSubmit" :loading="loading">提现</a-button>
            </a-form-item>
          </div>
        </div>
      </div>
    </a-layout>
  </a-modal>
</template>
<script>
const formItemLayout = {
  labelCol: { span: 3 },
  wrapperCol: { span: 18 }
}
import {mapState} from 'vuex'
export default {
  name:'HomePageInfo',
  props:{
     CompanyInfoVisiable: {
      require: true,
      default: false
    },
    CompanyInfoData: {
      require: true
    },
  },
  computed:{
      show: {
        get: function () {
          return this.CompanyInfoVisiable
        },
        set: function () {
        }
      },
      ...mapState({
      user: state => state.account.user,
      currency: state => state.setting.currency,
      date: state => state.dict.dicts.sys_settings_withdrawal_date,
    }),
  },
  data(){
    return {
    formItemLayout,
    loading: false,
    amount: ''
    }
  },
  methods:{
    reset () {
      this.loading = false
      this.amount = ''
    },
    handleCancleClick () {
      this.reset()
      this.$emit('close')
    },
    handleSubmit () {
      if (this.CompanyInfoData.availableBalance < this.amount) {
        this.$message.error('提现金额不能大于可提现金额！')
        return
      }
      if (this.amount == 0 && !this.amount) {
        this.$message.error('提现金额不能空且不能为零！')
        return
      }
      let date = new Date()
      if (date.getDate() != this.date[0].valuee) {
        this.$message.success('未到提现日期，具体请看提现日期规定！');
        return
      }
      this.loading = true
          this.$post('company/withdrawal', {companyCode: this.user.companyCode
          , amount: this.amount}).then((r) => {
            this.reset()
            this.$emit('success')
          }).catch(() => {
            this.loading = false
            this.$message.error('提现失败！')
          })
    },
    allIn () {
      let date = new Date()
      if(this.CompanyInfoData.availableBalance == 0){
        this.$message.success('你现可提现余额为0！');
        return false
      }
      if (date.getDate() != this.date[0].valuee) {
        this.$message.success('未到提现日期，具体请看提现日期规定！');
        return false
      }
      this.loading = true
      this.$post('company/withdrawal', {companyCode: this.user.companyCode
          , amount: this.CompanyInfoData.availableBalance}).then((r) => {
            this.reset()
            this.$emit('success')
          }).catch(() => {
            this.loading = false
            this.$message.error('提现失败！')
          })
    },
  }
}
</script>
<style lang="less" scoped>
@import "HomePageInfo";
</style>



// WEBPACK FOOTER //
// src/views/HomePageInfo.vue